import { render, staticRenderFns } from "./updateEmail.vue?vue&type=template&id=4bf66ed2&scoped=true&"
import script from "./updateEmail.vue?vue&type=script&lang=js&"
export * from "./updateEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf66ed2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bf66ed2')) {
      api.createRecord('4bf66ed2', component.options)
    } else {
      api.reload('4bf66ed2', component.options)
    }
    module.hot.accept("./updateEmail.vue?vue&type=template&id=4bf66ed2&scoped=true&", function () {
      api.rerender('4bf66ed2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/user/center/updateEmail.vue"
export default component.exports